import angular from 'angular';

let InsuranceCityDetailController = function ($filter, $mdDialog, $scope, $state, Toast, Insurance) {
  let $ctrl = this;

  $ctrl.id = $state.params.id;
  $ctrl.uf = $state.params.uf;
  $ctrl.isEdit = false;
  $ctrl.city;

  angular.extend($ctrl, {
    clearForm,
    handleSave,
    handleDelete,

  });

  activate();

  function activate() {
    clearForm();
    $ctrl.state_id = null
    loadResource($ctrl.id);
  }

  function clearForm(form) {

    if (form) {
      form.$setPristine();
      form.$setUntouched();
    }
  }

  function handleDelete(card, event) {
    let confirmMessage = 'card-detail-delete-confirm-text';

    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')(confirmMessage))
      .ariaLabel($filter('translate')(confirmMessage))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Insurance
          .destroy(card)
          .then(response => {
            Toast.success($filter('translate')('card-detail-delete-success'));
            $ctrl.deleting = false;
            $state.go('card.list')
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
            console.log('err:', err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {
      });
  }

  function handleSave(form, state) {
    if (!form.$valid) {
      Toast.error($filter('translate')('common-form-incomplete'));
      return;
    }
    state.save = $ctrl.city.id != null && $ctrl.city.id !== '';
    save(state);
  }

  // Local functions
  function loadResource(id) {
    if (id) {
      $ctrl.uiState = 'LOADING';
      const resource = JSON.parse(localStorage.getItem('cityInsurance'));
      console.log("resource,", resource)
      $ctrl.isEdit = true;
      $ctrl.city = {
        id: resource.id,
        sigla: resource.sigla,
        uf: $ctrl.uf,
        description: resource.descricao
      };
      Insurance.listCities(resource.sigla)
        .then(cities => {
          $ctrl.resources = cities;
          $ctrl.loadingCities = false;
          $ctrl.uiState = 'COMPLETE';
        })
        .catch(err => {
          console.log('err:', err);
          $ctrl.loadingCities = false;
        });

    } else {
      $ctrl.city = {
        uf: $ctrl.uf
      }
      $ctrl.uiState = 'COMPLETE';
    }
  }

  function loadDomainResources() {
    let promises = [];

    promises.push(Module.index());

    return Promise.all(promises);
  }

  function save(card) {
    $ctrl.saving = true;

    Insurance
      .saveCity(card)
      .then(response => {
        Toast.success($filter('translate')('insurance-city-detail-save-success'));
        $ctrl.card = response;
        $ctrl.saving = false;
        $state.go('insurance.state');
      })
      .catch(err => {
        if (typeof err.data == "string") {
          Toast.error($filter('translate')(err.data));
        } else {
          let defaultErrMsg = 'common-server-error';
          let fourONineMsg = 'card-detail-409-error';
          let message = err.status == 409 ? fourONineMsg : defaultErrMsg;
          Toast.error($filter('translate')(message));
        }
        console.log('err:', err);
        $ctrl.saving = false;
      });
  }
}

InsuranceCityDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', 'Toast', 'Insurance'];

export default InsuranceCityDetailController;



// WEBPACK FOOTER //
// ./client/app/components/insurance/city/insurance-city-detail.controller.js